import { Divider } from '@mantine/core';

import { Card } from '../../DataDisplay';
import { Stack } from '../../Layout';

type Props = {
  topComponent: JSX.Element | null;
  bottomComponent: JSX.Element | null;
  hideDivider?: boolean;
};

export const SplitLayoutCard = ({ topComponent, bottomComponent, hideDivider = false }: Props) => {
  return (
    <Card shadow="md" padding={'xl'} withBorder={false}>
      <Stack gap={'lg'}>
        {topComponent}
        {topComponent && bottomComponent && !hideDivider && <Divider color="cobalt.0" size={2} />}
        {bottomComponent}
      </Stack>
    </Card>
  );
};
